// extracted by mini-css-extract-plugin
module.exports = {"scoop-types":"ScoopTypesInput_scoop-types__2uG1R","checkboxes":"ScoopTypesInput_checkboxes__Rdn91"};